import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

/** Réglages généraux. */
export interface Settings {
  batchNumberPattern: string;
  referenceWorkCenter: string | null;
}

export function useSettings() {
  return useQuery({ queryKey: ['settings'], queryFn: () => api.get<Settings>('/settings') });
}

export function useSaveBatchPattern() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pattern: string) => api.put<Settings>('/settings/batch-number-pattern', { pattern }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['settings'] }),
  });
}

export function useSaveReferenceWorkCenter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (workCenter: string | null) => api.put('/settings/reference-work-center', { workCenter }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['settings'] }),
  });
}

/** Aperçu serveur d'un template (source unique de vérité pour l'expansion). */
export function useBatchNumberPreview(pattern: string) {
  return useQuery({
    queryKey: ['batch-number-preview', pattern],
    queryFn: () => api.get<{ example: string }>(`/settings/batch-number-preview?pattern=${encodeURIComponent(pattern)}`),
    enabled: pattern.trim().length > 0,
  });
}
